/**
 * Logos hero module: rotate visible slots when more logos exist than shown.
 */
(function () {
	var INTERVAL_MS = 2000;
	var DURATION_MS = 400;
	var MD_QUERY = '(min-width: 768px)';
	var LG_QUERY = '(min-width: 992px)';

	function getVisibleCount() {
		if (window.matchMedia(LG_QUERY).matches) {
			return 6;
		}

		if (window.matchMedia(MD_QUERY).matches) {
			return 4;
		}

		return 2;
	}

	function parseLogos(grid) {
		try {
			return JSON.parse(grid.getAttribute('data-logos') || '[]');
		} catch (error) {
			return [];
		}
	}

	function buildLayerContent(logo) {
		var img = document.createElement('img');
		img.className = 'logos__image img-fluid';
		img.src = logo.src;
		img.alt = logo.title || '';
		img.loading = 'lazy';
		img.decoding = 'async';
		if (logo.width > 0 && logo.height > 0) {
			img.width = logo.width;
			img.height = logo.height;
		}

		if (logo.url) {
			var link = document.createElement('a');
			link.className = 'logos__link';
			link.href = logo.url;
			link.target = logo.target || '_self';
			if (link.target === '_blank') {
				link.rel = 'noopener noreferrer';
			}
			link.appendChild(img);
			return link;
		}

		return img;
	}

	function createLayer(logo, extraClass) {
		var layer = document.createElement('div');
		layer.className = 'logos__layer ' + extraClass;
		layer.appendChild(buildLayerContent(logo));
		return layer;
	}

	function getPool(visibleIndices, total) {
		var visibleSet = new Set(visibleIndices);
		var pool = [];

		for (var index = 0; index < total; index += 1) {
			if (!visibleSet.has(index)) {
				pool.push(index);
			}
		}

		return pool;
	}

	function pickRandom(items) {
		return items[Math.floor(Math.random() * items.length)];
	}

	function initGrid(grid) {
		if (grid.getAttribute('data-logos-rotate') !== '1') {
			return;
		}

		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			return;
		}

		var logos = parseLogos(grid);
		var visibleCount = getVisibleCount();

		if (logos.length <= visibleCount) {
			return;
		}

		var slots = Array.prototype.slice.call(grid.querySelectorAll('.logos__item'), 0, visibleCount);
		var visibleIndices = slots.map(function (slot, index) {
			return index;
		});

		function animateSwap(slot, slotIndex, nextLogoIndex) {
			if (slot.dataset.animating === '1') {
				return;
			}

			var media = slot.querySelector('.logos__media');
			var currentLayer = media ? media.querySelector('.logos__layer--current') : null;

			if (!media || !currentLayer) {
				return;
			}

			slot.dataset.animating = '1';

			var incomingLayer = createLayer(logos[nextLogoIndex], 'logos__layer--incoming');
			media.appendChild(incomingLayer);

			requestAnimationFrame(function () {
				requestAnimationFrame(function () {
					currentLayer.classList.add('logos__layer--outgoing');
					incomingLayer.classList.add('is-active');
				});
			});

			var finished = false;

			function finishTransition() {
				if (finished) {
					return;
				}

				finished = true;
				currentLayer.remove();
				incomingLayer.classList.remove('logos__layer--incoming', 'is-active');
				incomingLayer.classList.add('logos__layer--current');
				slot.dataset.animating = '0';

				visibleIndices[slotIndex] = nextLogoIndex;
			}

			incomingLayer.addEventListener('transitionend', finishTransition, { once: true });
			window.setTimeout(finishTransition, DURATION_MS + 100);
		}

		window.setInterval(function () {
			visibleCount = getVisibleCount();

			if (logos.length <= visibleCount) {
				return;
			}

			slots = Array.prototype.slice.call(grid.querySelectorAll('.logos__item'), 0, visibleCount);

			if (visibleIndices.length > visibleCount) {
				visibleIndices = visibleIndices.slice(0, visibleCount);
			}

			var pool = getPool(visibleIndices, logos.length);
			if (!pool.length) {
				return;
			}

			var availableSlots = slots.filter(function (slot) {
				return slot.dataset.animating !== '1';
			});

			if (!availableSlots.length) {
				return;
			}

			var slot = pickRandom(availableSlots);
			var slotIndex = slots.indexOf(slot);

			if (slotIndex === -1) {
				return;
			}

			var nextLogoIndex = pickRandom(pool);
			animateSwap(slot, slotIndex, nextLogoIndex);
		}, INTERVAL_MS);
	}

	function init() {
		document.querySelectorAll('.logos__grid[data-logos-rotate="1"]').forEach(initGrid);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
